import PropTypes            from 'prop-types';
import React, { Component } from 'react';

// https://stackoverflow.com/a/42234988
export default class OutsideAlerter extends Component {
  constructor(props) {
    super(props);

    let state = { style: { top: '0px' } };
    if (props.style) {
      state.style = Object.assign(state.style, props.style);
    }

    this.state = state;
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   * [skipoutsidealerter="true"] add this node attribute to add an exception from this click listener
   */
  handleClickOutside(event) {
    // console.log('outside-alerter-click-outside', event.target);
    if (this.wrapperRef && !this.wrapperRef.contains(event.target) && !event.target.hasAttribute('skipoutsidealerter') && this.props.onAlert) this.props.onAlert();
  }

  render() {
    const { className, onClick, children } = this.props;
    const { style }     = this.state;

    const props = { className, style, onClick };

    return <div {...props} ref={this.setWrapperRef}  data-testid="outsidealerter-container">{ ( typeof children === 'function' ) ? children(props) : children }</div>;
  }
}
